class SmoothScroll {
  constructor() {
    this.initLenis();
  }

  async initLenis() {
    // Import modern Lenis dynamically via jsDelivr CDN
    const { default: Lenis } = await import('https://cdn.jsdelivr.net/npm/lenis@1.1.18/+esm');

    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // standard easing
      direction: 'vertical', // vertical, horizontal
      gestureDirection: 'vertical', // vertical, horizontal, both
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    // Sync with requestAnimationFrame
    requestAnimationFrame(this.raf.bind(this));

    // Expose lenis globally if needed by other scripts (like Splide sliders or headers)
    window.lenis = this.lenis;

    // Fix for native scroll-behavior smooth which conflicts with Lenis
    document.documentElement.style.scrollBehavior = 'auto';
  }

  raf(time) {
    this.lenis.raf(time);
    requestAnimationFrame(this.raf.bind(this));
  }
}

// Initialize on DOMContentLoaded or immediately since this is type="module"
new SmoothScroll();
